export const WARNING_THRESHOLD = 25;
export const CRITICAL_THRESHOLD = 10;

export function getBalanceTone(available) {
  if (available <= 0) return 'esgotado';
  if (available <= CRITICAL_THRESHOLD) return 'critico';
  if (available <= WARNING_THRESHOLD) return 'atencao';
  return 'normal';
}
